import ReviewLanding from "./container/ReviewLandingContainer";
import ReviewQuestions from "./container/ReviewQuestionsContainer";

export { ReviewQuestions };
export default ReviewLanding;
